var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTshirts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 345.47 345.47",
    style: {
      enableBackground: "new 0 0 345.47 345.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1336_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    style: {
      fill: "#1DD2A5"
    },
    d: "M305.41,179.52v140.07c0,14.29-11.59,25.88-25.88,25.88H65.94 c-14.29,0-25.88-11.59-25.88-25.88V179.52c0-7.71,4.24-14.76,10.99-18.48c10.17-5.61,23.74-15.11,23.74-25.89V0h30.49 c0,37.25,30.2,67.45,67.45,67.45c37.26,0,67.46-30.2,67.46-67.45h30.48v135.15c0,10.78,13.57,20.28,23.75,25.89 C301.17,164.76,305.41,171.81,305.41,179.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    style: {
      fill: "#2CB79A"
    },
    d: "M294.42,161.04c-10.18-5.61-23.75-15.11-23.75-25.89V0h-30.48 c0,37.249-30.198,67.447-67.455,67.45v278.02H279.53c14.29,0,25.88-11.59,25.88-25.88V179.52 C305.41,171.81,301.17,164.76,294.42,161.04z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    style: {
      fill: "#FAE16E"
    },
    d: "M231.985,183.117h-12.333c-11.414,0-20.667-9.253-20.667-20.667v-36h53.667v36 C252.652,173.864,243.399,183.117,231.985,183.117z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1338_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_36_",
    x: 40.06,
    y: 270.57,
    style: {
      fill: "#FCE98E"
    },
    width: 265.35,
    height: 32.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    x: 172.735,
    y: 270.57,
    style: {
      fill: "#FAE16E"
    },
    width: 132.675,
    height: 32.63
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1340_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_33_",
    x: 40.06,
    y: 206.88,
    style: {
      fill: "#FCE98E"
    },
    width: 265.35,
    height: 32.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_32_",
    x: 172.735,
    y: 206.88,
    style: {
      fill: "#FAE16E"
    },
    width: 132.675,
    height: 32.64
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirts);
export default __webpack_public_path__ + "static/media/tshirts.c25e52c3bae4106a406b7a0d448ea3cb.svg";
export { ForwardRef as ReactComponent };